
import { Component, Prop, Vue } from 'vue-property-decorator'
import { TableColumnType, RenderHeaderData, TableColumnFixedType, SortOrders, TableColumn, ElementUIHorizontalAlignment, sortable } from '@/utils/types/tables'

@Component({
  name: 'hs-table-column'
})
export default class HsTableColumn extends Vue {
  private isHeader = !1

  private isScopedDefault = !0

  beforeMount () {
    if (this.$scopedSlots && !!this.$scopedSlots.default) {
      this.isScopedDefault = !0
    }
    if (this.$scopedSlots && !!this.$scopedSlots.header) {
      this.isHeader = !0
    }
  }

  @Prop({ type!: String })
  private type!: TableColumnType

  @Prop({ type!: String })
  private label!: string

  @Prop({ type!: Array })
  private filters!: any[]

  @Prop({ type!: [Number, Function] })
  private index!: string| ((index: any) => number)

  @Prop({ type!: String })
  private columnKey!: string

  @Prop({ type!: String })
  private prop!: string

  @Prop({ type!: [String, Number] })
  private width!: string|number

  @Prop({ type!: String })
  private minWidth!: string

  @Prop({ type!: [Boolean, String] })
  private fixed!: boolean | TableColumnFixedType

  @Prop({ type!: Function })
  private renderHeader!: ((h: any, col: RenderHeaderData) => number)

  @Prop({ type!: Function })
  private sortMethod!: ((a: any, b: any) => number)

  @Prop({ type!: [String, Boolean], default: !1 })
  private sortable!: sortable

  @Prop({ type!: Array, default: () => (['ascending', 'descending', null]) })
  private sortOrders!: SortOrders[]

  @Prop({ type!: Boolean, default: !0 })
  private resizable!: boolean

  @Prop({ type!: [String, Array, Function] })
  private sortBy!: string|any[]|((row: any, index: any) => string|any[])

  @Prop({ type!: Function })
  private formatter!: (row: object, column: TableColumn) => any

  @Prop({ type!: Boolean, default: !1 })
  private showOverflowTooltip!: boolean

  @Prop({ type!: String, default: 'left' })
  private align!: ElementUIHorizontalAlignment

  @Prop({ type!: String })
  private headerAlign!: ElementUIHorizontalAlignment

  @Prop({ type!: String })
  private className!: string

  @Prop({ type!: String })
  private labelClassName!: string

  @Prop({ type!: Function })
  private selectable!: (row: object, index: number) => boolean

  @Prop({ type!: Boolean, default: !1 })
  private reserveSelection!: boolean

  @Prop({ type!: Boolean, default: !0 })
  private filterMultiple!: boolean

  @Prop({ type!: String })
  private filterPlacement!: string

  @Prop({ type!: Function })
  private filterMethod!: (value: any, row: object) => boolean

  @Prop({ type!: Array })
  private filteredValue!: any[]
}
